import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
import { type BlocksContent } from "@strapi/blocks-react-renderer";
import { LegalApiResponse } from "../types/legal-types";

export const fetchPrivacyPolicy = createAsyncThunk(
  "legal/fetchPrivacyPolicy",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<LegalApiResponse>(
        "/privacy-policy?populate=*"
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const fetchTermsOfService = createAsyncThunk(
  "legal/fetchTermsOfService",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get<LegalApiResponse>(
        "/terms-of-service?populate=*"
      );
      return response.data;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

type LegalState = {
  privacyPolicy: BlocksContent | null;
  termsOfService: BlocksContent | null;
  status: "idle" | "loading" | "succeeded" | "failed";
  error: string | null;
};

const initialState: LegalState = {
  privacyPolicy: null,
  termsOfService: null,
  status: "idle",
  error: null,
};

const legalSlice = createSlice({
  name: "legal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPrivacyPolicy.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchPrivacyPolicy.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.privacyPolicy = action.payload.data.attributes.description;
      })
      .addCase(fetchPrivacyPolicy.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      })
      .addCase(fetchTermsOfService.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchTermsOfService.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.termsOfService = action.payload.data.attributes.description;
      })
      .addCase(fetchTermsOfService.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload as string;
      });
  },
});

export default legalSlice.reducer;
